import { SystemService } from '@core/services/system/system.service';
import { User } from 'src/app/core/models/entities/user/user';
import { AuthService } from 'src/app/core/services/auth/auth.service';

import { CommonModule } from '@angular/common';
import { Component, OnInit, Renderer2, inject } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <section
      id="container-footer"
      [style.background-color]="systemService.configuracao()?.corPredominante">
      <a
        class="link-logo"
        href="https://www.egtec.com.br"
        target="_blank"
        *ngIf="systemService.configuracao()?.exibeLogoEGTEC">
        <img
          src="../../../../assets/logos/confear/egtec-branco-pq-rodape.png"
          id="logoEgtecRodape"
          alt="CONFEAR é um produto EGTEC"
          title="CONFEAR é um produto EGTEC" />
      </a>
    </section>
  `,
  imports: [CommonModule],
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  user: User;
  systemService = inject(SystemService);

  constructor(
    private authService: AuthService,
    private render: Renderer2
  ) {}

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.authService.getUserObservable().subscribe(response => {
      if (response) {
        this.user = response;
      }
    });
  }
}
